import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
export function LocalIngredientsSection() {
  const benefits = ['Ingredientes que encuentras en cualquier mercado', 'Sin productos importados ni caros', 'Recetas adaptadas a Latinoamérica', 'Alimentos frescos y de temporada'];
  return <section className="py-12 sm:py-16 md:py-20 bg-gradient-to-br from-baby-cream to-white" data-id="element-646">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-647">
        <div className="text-center mb-8 sm:mb-12 animate-fade-in-up" data-id="element-648">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-649">
            Ingredientes Reales y Locales
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-650">
            Recetas con ingredientes que encuentras en cualquier súper de
            Latinoamérica
          </p>
        </div>

        <div className="relative rounded-baby-lg overflow-hidden shadow-baby-glow mb-8 sm:mb-12 animate-fade-in-up" style={{
        animationDelay: '0.2s'
      }} data-id="element-651">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hYoEZeFS7SssB62mDM1rWv/6-cualquier_super_de_Latinoamerica%E2%80%9D..png" alt="Ingredientes locales - Bananas, aguacate, zanahorias, lentejas, mango y más" className="w-full h-auto" data-id="element-652" />
        </div>

        <div className="grid sm:grid-cols-2 gap-4 sm:gap-6 stagger-children" data-id="element-653">
          {benefits.map((benefit, index) => <div key={index} className="bg-white/90 backdrop-blur-baby p-5 sm:p-6 rounded-baby-lg border-2 border-baby-pink-light shadow-baby-soft hover:shadow-baby-glow transition-all" data-id="element-654">
              <div className="flex items-center gap-3" data-id="element-655">
                <div className="flex-shrink-0 w-8 h-8 bg-baby-gradient-pink rounded-full flex items-center justify-center shadow-baby-soft" data-id="element-656">
                  <CheckCircleIcon className="w-5 h-5 text-white" data-id="element-657" />
                </div>
                <p className="text-sm sm:text-base font-semibold text-gray-800" data-id="element-658">
                  {benefit}
                </p>
              </div>
            </div>)}
        </div>

        <div className="mt-8 sm:mt-12 text-center animate-fade-in-up" style={{
        animationDelay: '0.4s'
      }} data-id="element-659">
          <div className="inline-block bg-gradient-to-br from-baby-pink-light to-baby-cream p-6 sm:p-8 rounded-baby-lg border-2 border-baby-pink shadow-baby-soft" data-id="element-660">
            <p className="text-lg sm:text-xl font-bold text-gray-900 mb-2" data-id="element-661">
              Sin ingredientes exóticos ni complicados
            </p>
            <p className="text-sm sm:text-base text-gray-700" data-id="element-662">
              Banana, aguacate, zanahoria, calabaza, lentejas, pollo, mango...
              Todo lo que ya conoces y tienes cerca.
            </p>
          </div>
        </div>
      </div>
    </section>;
}